import { goWechat } from '@/utils';
import { useEffect, useRef } from 'react';
import { isEnv } from '@/utils';
import './index.scss';

interface initProps {
  title?: string; // 标题
  info?: any;
  imgChild: any; //图片
  clicButton?: any;
}
const CustomerError = (props: initProps) => {
  const { info, imgChild, clicButton } = props;
  const btnBoxRef: any = useRef(null);
  useEffect(() => {
    setTimeout(() => {
      goWechat(btnBoxRef);
    }, 500);
  }, [btnBoxRef]);
  return (
    <div className="error-index">
      <div className="img">{imgChild}</div>
      <span className="info">{info}</span>
      {isEnv() === 'WxChat' ? (
        <div className="btn">
          <span ref={btnBoxRef} className="coin_overdueBtnH5" />
          {clicButton}
        </div>
      ) : null}
    </div>
  );
};

export default CustomerError;
